import type { DisplayPublic } from '../api';
import { useDisplayStore } from '../store';
import { Scoreboard } from './scoreboard/Scoreboard';
import { FootballScoreboard } from './scoreboard/FootballScoreboard';
import { SoccerScoreboard } from './scoreboard/SoccerScoreboard';
import type { ScoreboardConfig } from './scoreboard/themes';
import { LiveBoard } from '../widget-engine/LiveBoard';

export function ScoreboardChannel({
  display,
  connected,
}: {
  display: DisplayPublic;
  connected: boolean;
  onUnpair: () => void;
}) {
  const config =
    (display.displayConfig as ScoreboardConfig | null | undefined) ?? null;
  const snapshot = useDisplayStore((s) => s.liveSnapshot);
  const isLive = !!(config?.assignedGameId && snapshot);
  const sport = snapshot?.sportSlug;

  // Opt-in: when the display config names a zone template, render through
  // the widget engine instead of the hardcoded layouts.
  if (config?.layoutTemplate) {
    return <LiveBoard config={config} />;
  }

  if (isLive && sport === 'football') {
    return (
      <FootballScoreboard
        snapshot={snapshot}
        isSample={false}
        connected={connected}
      />
    );
  }
  if (isLive && sport === 'soccer') {
    return (
      <SoccerScoreboard
        snapshot={snapshot}
        isSample={false}
        connected={connected}
      />
    );
  }

  return (
    <Scoreboard
      config={config}
      snapshot={isLive ? snapshot : null}
      isSample={!isLive}
      connected={connected}
    />
  );
}
